<template>
    <div class="tos">
        <el-checkbox 
        v-model="model"
        ></el-checkbox>
        
        <span class="tos-text">
            我已接受并同意网站

            <span @click="dialogOpen">
                《用户服务条款》
            </span>
        </span>

        <my-dialog
        title="用户服务条款"
        v-model="dialogVisible"
        >
            <div class="rich-text" v-html="content"></div>
        </my-dialog>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dialogVisible: false,

            content: `<h4 class="ta-center">注册协议</h4><p>欢迎您加入${this.$siteConfig.title}(以下简称“${this.$siteConfig.jc_title}”)，我们将竭诚为您服务！在此，您可以浏览各类公开信息，展示优质资源，寻求合作伙伴，还可以享受到${this.$siteConfig.jc_title}提供的一系列优质服务。在注册之前，请您务必仔细阅读以下条款：</p><p>第1章协议的订立和效力</p><p>${this.$siteConfig.jc_title}运营服务的所有权和运作权归${this.$siteConfig.companyName}所有。注册用户（以下简称“用户”）完成注册程序并勾选“我已接受并同意网站《用户服务条款》”后，即视为与${this.$siteConfig.jc_title}订立协议并接受所有的服务条款。</p><p>本协议自用户勾选“我已接受并同意网站《用户服务条款》”后开始生效。如果本协议的某一条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款在不影响协议目的的情况下仍应有效并且有约束力。</p><p>第2章协议的修订和续签</p><p>用户知悉，对${this.$siteConfig.jc_title}提供的注册协议标准版本及其修订的完全接受是用户同意签订本协议的前提条件。${this.$siteConfig.jc_title}在必要时会修订本协议的部分条款，条款内容一旦发生变动，将会在用户进入下一步使用前的页面上提示修改内容。如果用户同意改动，则再次激活“同意”按钮。如果用户不接受，则视为自动放弃使用服务的资格。</p><p>第3章使用规则</p><p>遵守中华人民共和国相关法律法规，包括但不限于《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》、《最高人民法院关于审理涉及计算机网络著作权纠纷案件适用法律若干问题的解释(法释[2004]1号)》、《全国人大常委会关于维护互联网安全的决定》、《互联网电子公告服务管理规定》、《互联网新闻信息服务管理规定》、《互联网著作权行政保护办法》和《信息网络传播权保护条例》、《互联网用户账号名称管理规定》等有关计算机互联网规定和知识产权的法律和法规、实施办法。</p><p>用户对其上传的内容负全部责任，所有用户不得在${this.$siteConfig.jc_title}任何页面发布、转载、传送含有下列内容之一的信息，否则${this.$siteConfig.jc_title}有权自行处理并不通知用户，情节严重的将暂停或取消用户资格，并保留对涉事用户进一步追究法律责任的权利：</p><p>1)违反宪法或法律法规规定的；</p><p>2)危害国家安全，泄漏国家机密，颠覆国家政权，破坏国家统一的；</p><p>3)损害国家荣誉和利益，损害公共利益的；</p><p>4)煽动民族仇恨、民族歧视，破坏民族团结的；</p><p>5)破坏国家宗教政策，宣扬邪教和封建迷信的；</p><p>6)散布谣言，扰乱社会秩序，破坏社会稳定的；</p><p>7)散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p><p>8)侮辱或者诽谤他人，侵害他人合法权益的；</p><p>9)煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；</p><p>10)以非法民间组织名义活动的；</p><p>11)含有法律、行政法规禁止的其他内容的。</p><p>用户在账号名称、头像和简介等注册信息中不得出现违法和不良信息。用户应保证在注册、使用${this.$siteConfig.jc_title}提供的相关服务等过程中提交的“用户资料”的合法性、真实性和准确性，并对此承担全部责任。</p><p>用户承诺对其发表或者上传于${this.$siteConfig.jc_title}的所有信息(即属于《中华人民共和国著作权法》规定的作品，包括但不限于文字、图片、音乐、电影、表演和录音录像制品和电脑程序等)均享有完整的知识产权，或者已经得到相关权利人的合法授权，务必保证信息来源的合法性；如用户违反本条规定造成${this.$siteConfig.jc_title}被第三人索赔的，用户应全额补偿${this.$siteConfig.jc_title}一切费用(包括但不限于各种赔偿费、诉讼代理费及为此支出的其它合理费用)。</p><p>机构用户注册时须提交规定格式的《管理员授权委托书》，管理员在${this.$siteConfig.jc_title}的所有活动均视为该用户的活动。</p><p>第4章用户的账号、密码和安全性</p><p>用户成功注册后将生成一个${this.$siteConfig.jc_title}“统一账号”，用户应妥善保管该账号及其对应的密码。如因用户未保管好自己的账号和密码，而对用户自身、${this.$siteConfig.jc_title}或第三方造成的损害，将由该用户负全部责任。同时，用户应对其账号下全部信息和所有活动负全部责任。用户若发现任何非法使用用户账号的情况，或其他安全漏洞，应立即告知${this.$siteConfig.jc_title}。</p><p>第5章用户隐私制度</p><p>尊重用户个人隐私是${this.$siteConfig.jc_title}的基本原则。${this.$siteConfig.jc_title}除依法行使信息公开、信息交互等权利外，不会通过其他途径公开、编辑或透露用户的注册信息。除非根据中华人民共和国国家安全机构、公安部门的要求或根据相应的法律程序或维护社会公共利益的要求。</p><p>第6章免责声明</p><p>${this.$siteConfig.jc_title}会尽量完善和提升平台服务，但不保证服务一定满足用户的要求，不保证服务不会中断，不保证服务的及时性、安全性、真实性，服务不会发生出错等。对于用户因使用${this.$siteConfig.jc_title}服务而造成直接或间接损失（包括但不限于因使用服务而造成的用户利润、商业信誉、资料损失或其他有形或无形损失），${this.$siteConfig.jc_title}不承担赔偿责任。</p><p>用户理解其可通过${this.$siteConfig.jc_title}服务同互联网上其他网络用户建立各种形式的联系，若其他网络用户通过此等联系侵犯用户的合法权利，则应由责任人依法承担所有责任，${this.$siteConfig.jc_title}对此不承担责任。</p><p>为了更好地提升服务，${this.$siteConfig.jc_title}需要进行服务器配置、系统维护升级，如进行前述配置或维护，${this.$siteConfig.jc_title}会提前24小时以上通过网络公告等方式通知用户。在此期间发生的服务暂停现象，或者由于网络通路的偶然阻塞造成服务应用故障，应属正常情况，不可视为${this.$siteConfig.jc_title}违约。</p><p>第7章结束服务</p><p>用户或${this.$siteConfig.jc_title}可随时根据实际情况结束服务。${this.$siteConfig.jc_title}不需对任何个人或第三方负责而随时结束服务。用户若反对任何服务条款或不同意后来修订的条款，或不满意${this.$siteConfig.jc_title}的服务，用户可行使以下权利：</p><p>1)不再使用${this.$siteConfig.jc_title}服务。</p还是><p>2)结束用户使用${this.$siteConfig.jc_title}服务的资格。</p><p>3)通告${this.$siteConfig.jc_title}结束对该用户的服务。</p><p>结束用户服务后，用户使用${this.$siteConfig.jc_title}服务的权利立即中止，${this.$siteConfig.jc_title}不再对用户承担任何义务。</p><p>第8章违约赔偿</p><p>如果因${this.$siteConfig.jc_title}违反有关法律、法规或本协议项下的相关条款而给用户造成损失，${this.$siteConfig.jc_title}同意承担由此造成的损害赔偿责任。用户同意保障和维护${this.$siteConfig.jc_title}及其他用户的共同利益，如因用户违反有关法律、法规或本协议项下的任何条款而给${this.$siteConfig.jc_title}网站或任何其他第三人造成损失，用户同意承担由此造成的损害赔偿责任。</p><p>第9章法律适用与争议解决</p><p>本协议的订立、执行和解释及争议的解决均应适用中国法律。如双方就本协议内容或其执行发生任何争议，首先应进行友好协商。协商不成时，任何一方均可向${this.$siteConfig.jc_title}所在地人民法院提起诉讼。</p><p>第10章协议的解释权</p><p>本协议的解释权归本${this.$siteConfig.jc_title}所有。如果其中有任何条款与国家现行的有关法律相抵触，则以国家法律的明文规定为准。</p>`,
        };
    },
    computed: {
        model: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        }
    },
    methods: {
        dialogOpen() {
            this.dialogVisible = true;
        },
        queryContent() {

        }
    }
};
</script>

<style lang="scss" scoped>
    @import '@css/var.scss';

    .tos{
        text-align: center;

        .tos-text{
            margin-left: 1em;
            cursor: default;

            span{
                cursor: pointer;
                color: $primaryColor;

                &:hover{
                    color: $primaryColor8;
                }
            }
        }
    }
</style>